import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button, Popover } from 'antd';
import moment from 'moment';

import TopNavigation from './TopNavigation';

import { API_ROOT } from '../config';
import { logoutUser } from '../redux/auth';

import styles from './styles.module.scss';

class HeaderLayout extends Component {
  _isMounted = false;

  state = {
    selectedCity: 343,
    notifications: [],
  };

  async componentDidMount() {
    this._isMounted = true;
    // Запрос к /api/data/darmen отключён
    // let { selectedCity } = this.state;
    // this.loadNotifications(selectedCity);
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  loadNotifications = async (value) => {
    try {
      const notifRes = await fetch(`${API_ROOT}/api/data/darmen`, { credentials: 'include' });
      const notifData = await notifRes.json();
      const { notifications } = notifData.data.model[0];
      if (this._isMounted) {
        this.setState({
          selectedCity: value,
          notifications,
        });
      }
    } catch (e) {
      if (this._isMounted) {
        this.setState({
          selectedCity: value,
          notifications: [],
        });
      }
    }
  };

  render() {
    const { notifications } = this.state;
    const { logoutUser, history } = this.props;

    let user = window.localStorage.getItem('user_params');
    if (user) {
      try {
        user = JSON.parse(user);
      } catch (e) {
        user = null;
      }
    }
    return (
      <header className={styles.header}>
        <div className="logo">
          <Button icon={'menu'} style={{ marginRight: 6 }}>
            Меню
          </Button>
          <a className={styles.logo} href="https://cc.krgsc.kz/">
            <img src="./images/gerb.svg" alt="logo" width="40px" />
            <h3>Карагандинская область</h3>
          </a>
        </div>
        <TopNavigation user={user} {...this.props} />
        <div>
          <Popover
            placement="bottomRight"
            title={<span>Уведомления</span>}
            content={
              <div className={styles.header__notifications}>
                {notifications.map((n, index) => (
                  <div key={index} className="notification">
                    <img
                      src="./images/mchs.png"
                      width={60}
                      height={60}
                      alt="МЧС"
                      style={{
                        float: 'left',
                        marginRight: 10,
                        marginBottom: 6,
                      }}
                    />
                    <div>
                      <div className="location">{n.location_name}</div>
                      <div className="date">
                        {moment(n.created_at).format('DD.MM.YYYY HH:mm:ss')}
                      </div>
                      <div className="title">{n.title}</div>
                      <div className="text">{n.text}</div>
                    </div>
                  </div>
                ))}
              </div>
            }
            trigger="click"
          >
            <Button icon="bell" style={{ marginRight: 50 }} />
          </Popover>
          {user && (
            <Popover
              placement="bottomRight"
              title={<span>Профиль</span>}
              content={
                <div className={styles.header__profile}>
                  <div>
                    <strong>Имя пользователя:</strong> {user.username}
                  </div>
                  <div>
                    <strong>ID пользователя:</strong> {user.userId}
                  </div>
                  {user.roles && user.roles.length > 0 && (
                    <div>
                      <strong>Роль:</strong> {user.roles[0].name}
                    </div>
                  )}
                  <div style={{ marginTop: 10 }}>
                    <Button size="small" type="primary" onClick={() => history.push('/profile')}>
                      Открыть профиль
                    </Button>
                  </div>
                </div>
              }
              trigger="click"
            >
              <Button icon="user" style={{ marginRight: 16 }}>
                {user.username}
              </Button>
            </Popover>
          )}
          <Button onClick={logoutUser} style={{ marginRight: 6 }}>
            Выйти
          </Button>
        </div>
      </header>
    );
  }
}

export default withRouter(connect(null, { logoutUser })(HeaderLayout));
